export default function pageTimer() {
  this.pageTimerTimeout = setTimeout(() => {
    if (this.pageTimeLeft > 0.1 && !this.testPaused) {
      this.pageTimeLeft -= 1;
      this.pageTimer();
    }
  }, 1000);
}
